import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=040206c7&"
import script from "./WalletList.vue?vue&type=script&lang=js&"
export * from "./WalletList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports